import axios from "axios";
import { getApiUrl } from "./utils/utils"

let BASE_URL = getApiUrl()

const api = axios.create({
    headers: {
        common: {
            Accept: "application/json",
            "Content-Type": "application/json"
        },
        post: {
            "Content-Type": "'application/x-www-form-urlencoded"
        }
    }
});


export const addNewDepoFile = (transferInfo, emailsList, tokenGiven, boxHash1, boxHash2, chunk, chunks, offset, file, chunkSize) => {
    
    const data = new FormData();
    data.append("userEmail", emailsList);
    data.append("token", tokenGiven);
    data.append("boxHash1", boxHash1);
    data.append("boxHash2", boxHash2);
    data.append("dzuuid", transferInfo.dzuuid);
    data.append("dzchunkindex", transferInfo.dzchunkindex);
    data.append("dztotalfilesize", transferInfo.dztotalfilesize);
    data.append("dztotalchunkcount", transferInfo.dztotalchunkcount);
    data.append("transferFilesName", transferInfo.transferFileName);
    data.append("type", "DEPOSIT-OUTSIDE");
    data.append("file", transferInfo.transferFile);
    data.append("transferText", document.getElementById("taDesc").value);
    data.append("sendEmail", transferInfo.sendEmail);
    data.append("method", "transferEncryptDepositBoxInside");
    return api
        .post(`${BASE_URL}/upload/upload.php`, data)
        .then(response => {
            return response.data;
        })
        .catch(e => {
            throw e;
        });
}

export const getFiles = (boxHash1, boxHash2, emailsList, tokenGiven, userHash1, userHash2) => {
    const data = new FormData();
    data.append('boxHash1', boxHash1);
    data.append('boxHash2', boxHash2);
    data.append('emailAddress', emailsList);
    data.append('token', tokenGiven);
    data.append('uh', userHash1);
    data.append('uh2', userHash2);
    return api
        .post(`${BASE_URL}/apiV2.php?depositGetOutside`, data)
        .then(response => {
            var dBox = document.getElementById("depositBox");
            if (response.data.length === 0) {
                dBox.classList.add("noElement");
            }
            return response.data;
        })
}

